export const API_URL = process.env.REACT_APP_API_URL;
export const LIBRARY_URL = process.env.REACT_APP_LIBRARY_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
